import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AdalService } from 'adal-angular4';
import { CommonService } from './Common.service';
import { RestApiService } from './rest-api.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { UserDetailsViewModel } from '../ViewModel/UserDetailsModel';
@Injectable()
export class LoginService {
  private readonly logout = 'Login/Logout';
  private readonly changePassword = 'Login/ChangePassword';
  private readonly getCurrentUserDetails = 'Login/GetCurrentUserDetails';
  private readonly validateExternalMemberLogin = 'Login/ExternalMemberLogin';
  private readonly validateCurentUserAccess = 'Login/ValidateCurentUserAccess';
  private readonly getMemberProjectSelection = 'Project/GetMemberProjectSelection';
  private readonly _url_PostForgetPasswordOTP = 'Login/PostForgetPasswordOTP';


  constructor(public router: Router, private adal: AdalService, public restApiService: RestApiService, public commonService: CommonService, private _encryptDecryptService:EncryptDecryptService) {
    this.adal.init({
      tenant: environment.tenant,
      clientId: environment.clientId,
      cacheLocation: environment.cacheLocation,
      localLoginUrl: environment.localLoginUrl,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.postLogoutRedirectUri
    });
  }

  public InternalMemberLogin(): void {
    this.adal.handleWindowCallback();
    this.adal.login();
  }

  public ExternalMemberLogin(user: any): Observable<any> {
    return this.restApiService.new_POST(this.validateExternalMemberLogin, user);
  }

  public GetCurrentUserDetails(user: any): Observable<any> {
    return this.restApiService.new_POST(this.getCurrentUserDetails, user).pipe(map(res=>{
      let decryptedObject:any = JSON.parse(this._encryptDecryptService.decrypt(res));
      let userdetailsModel:UserDetailsViewModel = new UserDetailsViewModel();
      userdetailsModel.memberId = decryptedObject.MemberId;
      userdetailsModel.memberName = decryptedObject.MemberName;
      userdetailsModel.memberShortName = decryptedObject.MemberShortName;
      userdetailsModel.companyCode = decryptedObject.CompanyCode;
      userdetailsModel.reportingTo = decryptedObject.ReportingTo;
      userdetailsModel.reportingToName = decryptedObject.ReportingToName;
      userdetailsModel.staffPSNo = decryptedObject.StaffPSNo;
      userdetailsModel.eccWebLogin = decryptedObject.EccWebLogin;
      userdetailsModel.designation = decryptedObject.Designation;
      userdetailsModel.eMailId = decryptedObject.EMailId;
      userdetailsModel.mobileNo = decryptedObject.MobileNo;
      userdetailsModel.isInternal = decryptedObject.IsInternal;
      userdetailsModel.isActive = decryptedObject.IsActive;
      userdetailsModel.groupId = decryptedObject.GroupId;
      userdetailsModel.jwtToken = decryptedObject.JWTToken;
      userdetailsModel.loginAuditNumber = decryptedObject.LoginAuditNumber;
      userdetailsModel.isDuplicateLogin = decryptedObject.IsDuplicateLogin;
      userdetailsModel.eipUserId = decryptedObject.EipUserId;
      userdetailsModel.result = decryptedObject.Result;
      userdetailsModel.successCode = decryptedObject.SuccessCode;
      userdetailsModel.successMessage = decryptedObject.SuccessMessage;
      return userdetailsModel;
    }));
  }

  public GetMemberProjectSelection(user: any): Observable<any> {
    return this.restApiService.new_POST(this.getMemberProjectSelection, user);
  }

  public ValidateCurentUserAccess(user: any): any {
    return this.restApiService.new_POST(this.validateCurentUserAccess, user);
  }

  public ChangePassword(user: any): Observable<any> {
    return this.restApiService.new_POST(this.changePassword, user);
  }
  public PostForgetPasswordOTP(Input: any): Observable<any> {
    return this.restApiService.new_POST(this._url_PostForgetPasswordOTP, Input);
  }

  public Logout(_isInternal: boolean): void {
    let user = {
      memberId: this.commonService.getLoggedInUserId(),
      isInternal: _isInternal,
      isLogoutTime: true
    }

    this.restApiService.new_POST(this.logout, user).subscribe((data: any) => {
      if (_isInternal) {
        sessionStorage.clear();
        localStorage.clear();
        this.commonService.redirectUserToPRAddComments = this.commonService.isAccesingPRAddCommentsPage;
        this.adal.logOut();
      }

      if (!_isInternal) {
        sessionStorage.clear();
        localStorage.clear();
        this.commonService.redirectUserToPRAddComments = this.commonService.isAccesingPRAddCommentsPage;
        this.router.navigate(['/authentication/login']);
      }
    });
  }

}
